exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group-text {\n    background-color: rgba(24, 28, 33, 0.06) !important;\n}\n", ""]);

// exports
